import { IDomain, HtmlType } from "../common/dto/idomain";
import { formatNumber } from "../common/field/renderer";
import { InputComponentType } from "../common/component/input/input";

class Weight implements IDomain<number> {

    public htmlType: HtmlType = "text";
    public inputComponent: InputComponentType = "textField";

    public format(valueToFormat?: number) {
        if (valueToFormat !== undefined) {
            return valueToFormat.toString() + " g";
        }
        return "";
    }

    public unformat(valueToUnformat: string) {
        if (valueToUnformat) {
            const escaped = formatNumber(valueToUnformat);
            if (escaped) {
                return +escaped;
            }
        }
        return undefined;
    }

    public validators = [];
}

export const weight = new Weight();
